module.exports = __webpack_public_path__ + "static/media/explore-tech-2022.26312fd2.jpg";